import { DsFormWordModelInterface } from '../interfaces/form-word-model/ds-form-word-model.interface';

export class DsFormWordModel {
  /**
   *
   */
  id: number;

  /**
   *
   */
  title: string;

  /**
   * Creates an instance of DsFormWordModel.
   *
   * @param json Json object
   */
  constructor(json: DsFormWordModelInterface) {
    this.id = json.id;
    this.title = json.title;
  }
}
